import { connect } from 'react-redux';
import HomePage from './HomePage';

export default connect()(HomePage);



// WEBPACK FOOTER //
// ./components/HomePage/index.js